export const PolyStyle = [ 
    {id: 0, name: "SOS"},
    {id: 1, name: "D CUT"},
    {id: 2, name: "U CUT"},
    {id: 3, name: "Paper Twisted"},
] 